import React from "react";
import {
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2 as Grid,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "./Button";
import { useDialogStyles } from "./css";
import { CloseOutlined } from "@mui/icons-material";

interface IDialog {
  open: boolean;
  onClose: (event: {}) => void;
  onConfirm?: (event: {}) => void;
  children: React.ReactNode;
  title?: string;
  isConfirmationButton?: boolean;
  maxWidth?: "lg" | "md" | "sm" | "xl" | "xs" | false;
  confirmButtonRef?: React.RefObject<HTMLButtonElement | null>;
  confirmButtonLabel?: string;
  isCancelButton?: boolean;
  greyHeader?: boolean;
  onEntered?: () => void;
  onExited?: () => void;
  disableRestoreFocus?: boolean;
}

function Dialog(props: IDialog) {
  const {
    open,
    onClose,
    onConfirm,
    children,
    title,
    isConfirmationButton,
    maxWidth = "sm",
    confirmButtonRef,
    confirmButtonLabel,
    isCancelButton,
    greyHeader,
    onEntered,
    onExited,
    disableRestoreFocus,
  } = props;
  const [translate] = useTranslation();
  const { classes, cx } = useDialogStyles();
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.between(0, 400));

  return (
    <MuiDialog
      open={open}
      maxWidth={maxWidth}
      fullWidth
      disableRestoreFocus={disableRestoreFocus}
      slotProps={{ transition: { onEntered, onExited } }}
      classes={{
        root: cx(classes.contentRoot, { [classes.grey]: greyHeader }),
      }}
    >
      <DialogTitle
        classes={{
          root: cx({
            [classes.dialogTitle]: !smallScreen,
            [classes.dialogTitleSmallScreen]: smallScreen,
          }),
        }}
      >
        <div className={classes.header}>
          <div className={classes.title}>{title}</div>
          <div>
            <IconButton onClick={onClose} size="large">
              <CloseOutlined className={classes.icon} />
            </IconButton>
          </div>
        </div>
      </DialogTitle>

      <DialogContent>{children}</DialogContent>

      <DialogActions>
        <Grid container direction="column" size="grow">
          {isConfirmationButton && (
            <Grid>
              <Button
                onClick={onConfirm}
                fullWidth={true}
                disableElevation
                ref={confirmButtonRef}
              >
                {confirmButtonLabel
                  ? confirmButtonLabel
                  : translate("continue", "Tęsti")}
              </Button>
            </Grid>
          )}
          {isCancelButton && (
            <div onClick={onClose} className={classes.cancelButton}>
              {translate("cancel")}
            </div>
          )}
        </Grid>
      </DialogActions>
    </MuiDialog>
  );
}

export default Dialog;
